export interface ServiceConfig {
  /**
   * Human readable service title shown in public pages, emails, etc.
   */
  title: string;
  /**
   * Optional per-client-type service titles.
   */
  titlesByClientType: Record<string, string>;
}

const DEFAULT_TITLE = '一元帳';
const DEFAULT_CLIENT_TYPE_TITLES = Object.freeze({
  bm: '一元帳ビルメンテナンス',
});

const normalizeClientType = (value?: string | null): string => {
  const normalized = (value ?? '').toString().trim().toLowerCase();
  if (!normalized || normalized === 'original') {
    return '';
  }
  return normalized;
};

/**
 * Project wide service configuration.
 * Update this object to change global branding values.
 */
const userConfig: Partial<ServiceConfig> = {
  title: '一元帳',
  titlesByClientType: {
    bm: '一元帳ビルメンテナンス',
  },
};

const resolvedConfig: ServiceConfig = {
  title: userConfig.title?.trim() || DEFAULT_TITLE,
  titlesByClientType: {
    ...DEFAULT_CLIENT_TYPE_TITLES,
    ...(userConfig.titlesByClientType ?? {}),
  },
};

export const SERVICE_CONFIG = Object.freeze(resolvedConfig);
export const SERVICE_TITLE = SERVICE_CONFIG.title;
export const SERVICE_TITLES_BY_CLIENT_TYPE = Object.freeze({
  ...SERVICE_CONFIG.titlesByClientType,
});

export const resolveServiceTitle = (clientType?: string | null): string => {
  const normalizedClientType = normalizeClientType(clientType);
  if (!normalizedClientType) {
    return SERVICE_TITLE;
  }
  return SERVICE_TITLES_BY_CLIENT_TYPE[normalizedClientType] ?? SERVICE_TITLE;
};

export const resolveServiceSystemName = (clientType?: string | null): string =>
  `${resolveServiceTitle(clientType)}システム`;
